import { render, staticRenderFns } from "./Blade2.vue?vue&type=template&id=bd6f9262&scoped=true&"
import script from "./Blade2.vue?vue&type=script&lang=ts&"
export * from "./Blade2.vue?vue&type=script&lang=ts&"
import style0 from "./Blade2.vue?vue&type=style&index=0&id=bd6f9262&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6f9262",
  null
  
)

export default component.exports